var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SVG } from '../global';
export var Cross = function (_a) {
    var svgProps = _a.svgProps, colour = _a.colour;
    var strokeColour = colour || 'black';
    return (React.createElement(SVG, __assign({ testId: "cross" }, svgProps, { width: "20px" }),
        React.createElement("line", { x1: "2", x2: "20", y1: "2", y2: "20", stroke: strokeColour, strokeWidth: "2", strokeLinecap: "round" }),
        React.createElement("line", { x1: "2", x2: "20", y1: "20", y2: "2", stroke: strokeColour, strokeWidth: "2", strokeLinecap: "round" })));
};
//# sourceMappingURL=cross.js.map